import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { ITrazoCorporativo, ITrazoCorporativoResp } from "@/shared/interfaces/erp/factibilidad_corporativo";

import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi()


///* Obtener trazo corporativos
export const useFetchGetTrazoCorporativos = (
  params: ITrazoCorporativo, enabled: boolean = true
) => {

  return useQuery({
    queryKey: ['trazocorporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return await getTrazoCorporativos(params ?? {})
    },
    refetchOnWindowFocus: false,
    enabled
  })
}

export const getTrazoCorporativos = async (data: ITrazoCorporativo) => {
  const queryParams = getUrlParamsFetch(data || {})
  return await get<ITrazoCorporativoResp>(`${urlBackend}api/v1/trazocorporativo/?${queryParams}`,
    true
  );
}


///* Buscar trazo corporativa por id

export const useFetchGetByIdTrazoCorporativos = (
  id: string
) => {
  return useQuery({
    queryKey: ['trazocorporativo', id],
    queryFn: async () => {
      return await getByIdTrazoCorporativos(id)
    },
    refetchOnWindowFocus: false,

  })
}

export const getByIdTrazoCorporativos = async (id: string) => {
  return await get<ITrazoCorporativo>(`${urlBackend}api/v1/trazocorporativo/${id}/`, true);
}


// ///* Crear una trazo corporativa
// export const useFetchPostFactibilidadCorporativo = (
//   {
//     enableSuccessAlert,
//     navigate
//   }: UseMutationsParams
// ) => {

//   const queryClient = useQueryClient();

//   const setAlert = useUiStore(s => s.setAlert);
//   return useMutation({
//     mutationFn: postFactibilidadCorporativo,
//     onSuccess: (data) => {

//       queryClient.invalidateQueries({ queryKey: ['trazocorporativo'] })

//       enableSuccessAlert
//         && setAlert(true, data.message, AlertSeverityEnum.success)

//       navigate && navigate(ROUTER_PATHS.noc.trazoCorporativoNav)
//     },
//     onError: (error) => handleAxiosError(error)
//   })
// }

// export const postFactibilidadCorporativo = async (data: ITrazoCorporativo) => {
//   return await post<IFactibilidadCorporativo>(`${urlBackend}api/v1/trazocorporativo/`, data, true)
// }

// ///* Actualizar una trazo corporativa
// export const useFetchPutFactibilidadCorporativo = (
//   {
//     enableSuccessAlert,
//     navigate,
//     returnUrl
//   }: UseMutationsParams
// ) => {

//   const queryClient = useQueryClient();
//   const setAlert = useUiStore(s => s.setAlert);
//   return useMutation({
//     mutationFn: putFactibilidadCorporativo,
//     onSuccess: (data) => {
//       queryClient.invalidateQueries({ queryKey: ['trazocorporativo', data.data.id_trazo_coorporativa] })

//       enableSuccessAlert
//         && setAlert(true, data.message, AlertSeverityEnum.success)

//       navigate && returnUrl && navigate(returnUrl)
//     },
//     onError: (error) => handleAxiosError(error)
//   })
// }

// export const putFactibilidadCorporativo = async (data: ITrazoCorporativo) => {
//   return await put<IFactibilidadCorporativo>(`${urlBackend}api/v1/trazocorporativo/${data.id_trazo_coorporativa}/`, data, true)
// }


